import React from 'react';
import type { FC } from 'react';

import { useCardDataContext } from '../../data-provider/context';
import { dataTestIds } from '../../configs';

import type { TIsNotVisible } from './models';

export const InvestEmitentsDetailCardIsNotVisible: FC<TIsNotVisible> = ({
    children,
    className,
}) => {
    const { card: assets } = useCardDataContext();

    const hasResult = assets.length;

    const asset = hasResult ? assets[0] : null;

    if (!asset || asset?.isVisible) {
        return null;
    }

    return (
        <section className={className} data-test-id={dataTestIds.isVisibleContainer}>
            {children}
        </section>
    );
};
